import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/AuthContext';
import { useAppStore } from '../store/AppContext';
import { StorageHelper } from '../utils/StorageHelper';
import { HostProvider } from '../utils/HostProvider';

const BotonVolverFlotante: FC = () => {
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const { lang } = dataApp;
  const [languaje] = useState(lang);
  const dataUser = useAuthStore();
  const fromApp = StorageHelper.getFromApp() as string;
  const isApp = dataUser.user.isApp === 'true';
  const fromUrl = StorageHelper.getFromUrl() as string;
  const isEroski = HostProvider.isEroski();

  const textoBotonFlotante = () => {
    let text = '';
    if (fromApp === 'web_ecommerce') {
      text = isEroski
        ? `${t('botonFlotante.volver.superOnline')}`
        : `${t('caprabo.botonFlotante.volver.superOnline')}`;
    } else if (fromApp === 'descanso') {
      text = `${t('botonFlotante.volver.descanso')}`;
    } else if (fromApp === 'tecno_electro') {
      text = `${t('botonFlotante.volver.electrohogar')}`;
    } else if (fromApp === 'web_azokamarket_ecommerce') {
      text = `${t('botonFlotante.volver.eroskiAzoka')}`;
    } else if (fromApp === 'web_familia_ecommerce') {
      text = `${t('botonFlotante.volver.familia')}`;
    }
    return text;
  };

  const clicBotonFlotante = () => {
    if (fromApp === 'web_ecommerce') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = isEroski
          ? `${process.env.REACT_APP_SERVER_SUPER}${t('link.super')}`
          : `${process.env.REACT_APP_CAPRABO_CASA}`;
      } else {
        window.location.href = fromUrl;
      }
    } else if (fromApp === 'descanso') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = `${process.env.REACT_APP_HOST_DESCANSO}/${
          languaje === 'en' || languaje === 'de' ? 'es' : languaje
        }/categorias`;
      } else {
        window.location.href = fromUrl;
      }
    } else if (fromApp === 'tecno_electro') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = `${process.env.REACT_APP_HOST_ELECTROHOGAR}/${
          languaje === 'en' || languaje === 'de' ? 'es' : languaje
        }`;
      } else {
        window.location.href = fromUrl;
      }
    } else if (fromApp === 'web_azokamarket_ecommerce') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = `${process.env.REACT_APP_HOST_AZOKA}`;
      } else {
        window.location.href = fromUrl;
      }
    } else if (fromApp === 'web_familia_ecommerce') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = `${process.env.REACT_APP_HOST_FAMILIA_ONLINE}`;
      } else {
        window.location.href = fromUrl;
      }
    }
  };

  return (
    <>
      {!isApp &&
      (fromApp === 'web_ecommerce' ||
        fromApp === 'descanso' ||
        fromApp === 'tecno_electro' ||
        fromApp === 'web_azokamarket_ecommerce' ||
        fromApp === 'web_familia_ecommerce') ? (
        <div className="boton-sticky">
          <button
            type="button"
            className="btn btn-fijo"
            onClick={() => {
              clicBotonFlotante();
            }}
          >
            <div className="icon icon-medium">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <polygon
                  fillRule="evenodd"
                  points="8.388 0 .667 8 8.388 16 9.084 15.278 2.525 8.482 16 8.482 16 7.461 2.58 7.461 9.084 .721"
                />
              </svg>
            </div>
            <p>{textoBotonFlotante()}</p>
          </button>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default BotonVolverFlotante;
